export default "__VITE_ASSET__BgMvsSdr__"